/**
 * Utility functions to check if code is running in browser environment
 * This prevents "ReferenceError: document is not defined" during SSR
 */

/**
 * Check if code is running in browser (not during SSR)
 * @returns {boolean} true if running in browser
 */
export const isBrowser = () => {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
};

/**
 * Safely access window object
 * @returns {Window|undefined} window object if available, undefined otherwise
 */
export const getWindow = () => {
  return typeof window !== 'undefined' ? window : undefined;
};

/**
 * Safely access document object
 * @returns {Document|undefined} document object if available, undefined otherwise
 */
export const getDocument = () => {
  return typeof document !== 'undefined' ? document : undefined;
};

